import constants from './constants.js'
import authHeader from './auth.header.js';
import { clearSession } from './session.js';
import { apiFetch } from './api.js';

const HOST_URL = constants.API_URL
const scheme = constants.API_SCHEME;

const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay))

export async function getConnection(userId) {
    let response = await apiFetch(HOST_URL + `/users/${userId}/connected`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })

    if (response.status === 204) {
        return true
    }

    return false
}

export async function saveConnection(userId) {
    let response = await apiFetch(HOST_URL + `/auth/saveConnection`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify({ user_id: parseInt(userId) })
    })

    if (response.ok) {
        return true
    }

    return false
}

async function disconnect(userId) {
    let response = await apiFetch(HOST_URL + "/auth/disconnect", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ user_id: parseInt(userId) })
    })

    if (response.ok) {
        return true
    }

    return false
}

export async function stillActive(userId, retryCount = 1) {
    if (!userId) {
        return false
    }

    for (let attempt = 0; attempt <= retryCount; attempt += 1) {
        try {
            const response = await apiFetch(HOST_URL + `/user/stillactive/${userId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    ...authHeader()
                }
            })

            if (response.status === 200) {
                return true
            }

            if (response.status === 204 || response.status === 404) {
                return false
            }

            if (response.status === 401) {
                return false
            }

            if (response.status === 403) {
                return null
            }

            if (response.status >= 500 && attempt < retryCount) {
                await sleep(250 * (attempt + 1))
                continue
            }

            return false
        } catch (error) {
            console.error('stillActive check failed', error)

            if (attempt < retryCount) {
                await sleep(250 * (attempt + 1))
                continue
            }

            return null
        }
    }

    return null
}


/**
 * @param {{
    * lastname: string,
    * fistname: string,
    * email: string,
    * country?: string 
    * password: string}} userInfo
    * 
 * @returns {Promise<{}>}
*/
async function registration(userInfo) {
    let response = await fetch(HOST_URL + "/users", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(userInfo)
    })
    .catch((err) => { console.log("HTTP caught in promise catch", err) })

    if (!response) {
        return Promise.reject({ message: "Une erreur inconnue est survenue" })
    }

    const jsonResponse = await response.json()
    console.log(jsonResponse)

    if (!response.ok) {
       return Promise.reject(response.status === "422" ? jsonResponse.errorList[0] : jsonResponse.message)
    }

    return Promise.resolve("Votre compte a bien été créé !")
}



/**
 * @param {string} email 
 * @param {string} password 
 * @returns {promise<void|error>}
**/
const login = async (email, password) => {
    console.log("HOST_URL", HOST_URL)
    console.log("scheme", scheme)

    let response = await fetch(HOST_URL + "/sign-in", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ email: email, password: password })
    })
    .catch((err) => {
        console.error(err)
    })

    if (!response) {
        return Promise.reject({ message: "Une erreur inconnue est survenue." })
    }

    if (!response.ok) { 
        return Promise.reject(await response.json())
    }

    return Promise.resolve(await response.json())
}


const logout = () => {
    clearSession()
}

const getCodeForResetPassword = async (email) => {
    let response = await fetch(HOST_URL + "/auth/resetPassword/code", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ email: email })
    })
    .catch((err) => {
        console.error(err)
    })

    if (!response) {
        return Promise.reject({ message: "Une erreur inconnue est survenue." })
    }

    if (!response.ok) { 
        return Promise.reject(await response.json())
    }

    return await response.json()
}

const verifyResetCode = async (email, code) => {
    let response = await fetch(HOST_URL + "/auth/resetPassword/code/check", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ email: email, code: code })
    })
    .catch((err) => {
        console.error(err)
    })

    if (!response) {
        return Promise.reject({ message: "Une erreur inconnue est survenue." })
    }

    if (!response.ok) { 
        return Promise.reject(await response.json())
    }

    return await response.json()
}

const resetPassword = async (email, code, password) => {
    let response = await fetch(HOST_URL + "/auth/resetPassword", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ email: email, code: code, password: password })
    })
    .catch((err) => {
        console.error(err)
    })

    if (!response) {
        return Promise.reject({ message: "Une erreur inconnue est survenue." })
    }

    if (!response.ok) { 
        return Promise.reject(await response.json())
    }

    return await response.json()
}

const isTwoFAActivated = async () => {
    let response = await fetch(HOST_URL + "/auth/2fa", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    })
    .catch((err) => {
        console.error(err)
    })

    if (!response) {
        return Promise.reject({ message: "Une erreur inconnue est survenue." })
    }

    if (!response.ok) { 
        return Promise.reject(await response.json())
    }

    const res = await response.json()
    if (res === 1) {
        return true
    }
    return false
}

const verify2faCode = async (email, code) => {
    let response = await fetch(HOST_URL + "/auth/2fa/check", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ email: email, code: code })
    })
    .catch((err) => {
        console.error(err)
    })

    if (!response) {
        return Promise.reject({ message: "Une erreur inconnue est survenue." })
    }

    if (!response.ok) { 
        return Promise.reject(await response.json())
    }

    return await response.json()
}

// const getCurrentUser = () => {
//     return JSON.parse(localStorage.getItem("user"))
// }

const AuthService = {
    login,
    logout,
    stillActive,
    getCodeForResetPassword,
    verifyResetCode,
    resetPassword,
    registration,
    disconnect,
    isTwoFAActivated,
    verify2faCode
}

export default AuthService;
